import {C, withAlpha } from "../../constants/theme";

export function Badge({ children, color=C.accent }) {
  return <span style={{ background:withAlpha(color, "22"), color, border:"1px solid "+withAlpha(color, "44"), borderRadius:6, padding:"2px 10px", fontSize:11, fontWeight:700, letterSpacing:1 }}>{children}</span>;
}
